'use strict';

import authPlugin from './authPlugin'

export default [authPlugin];



// WEBPACK FOOTER //
// ./client/store/plugins/index.js